<template>
  <button v-on:click='download' class='button'>Download</button>
</template>

<script>
import downloadController from '../controllers/download';

export default {
  name: 'Download',
  methods: {
    download() {
      downloadController.download();
    },
  },
};
</script>

<style scoped>

</style>
